export default __webpack_public_path__ + "assets/images/d27481f164cdb94bf15c32207de505d5.png";